<div class="modal-header">
  <h4 class="modal-title">
    <i data-feather="plus"></i> Yeni Firma Ekle
  </h4>
</div>
<div class="modal-body"  *blockUI="'section-blocks'">
  <form [formGroup]="companyForm" (ngSubmit)="onSubmit()" class="mt-2">
    <div class="row">
      <div class="col-12">
        <div class="form-group mb-2">
          <label for="title">Firma Adı</label>
          <input type="text" formControlName="title" class="form-control" placeholder="Firma adı" />
        </div>
      </div>

      <div class="col-md-6 col-12">
        <div class="form-group mb-2">
          <label for="title">İndirim Oranı</label>
          <input type="text" formControlName="discountRate" class="form-control" placeholder="İndirim Oranı" />
        </div>
      </div>

      <div class="col-md-6 col-12">
        <div class="form-group mb-2">
          <label for="title">Vadeli Gün</label>
          <input type="text" formControlName="futureDay" class="form-control" placeholder="İndirim Oranı" />
        </div>
      </div>

      <div class="col-md-6 col-12">
        <div class="form-group mb-2">
          <label for="type">Kategori</label>
          <ng-select [items]="categories" formControlName="categoryId" placeholder="Kategory Seç" bindValue="id"
            bindLabel="categoryName"></ng-select>
        </div>
      </div>

      <div class="col-md-6 col-12">
        <div class="form-group mb-2">
          <label for="responsiblePerson">Para birimi</label>
          <ng-select [items]="currencies" [searchable]="false" formControlName="currencyId" bindLabel="currencyName"
            bindValue="id" placeholder="Para birimi seç"></ng-select>
        </div>
      </div>
    </div>
    <div class="ml-1 d-flex justify-content-end">
      <button type="submit" class="btn btn-success mr-1" rippleEffect [disabled]="companyForm.invalid">Kaydet</button>
      <button type="reset" class="btn btn-outline-secondary" rippleEffect (click)="closeModal()">İptal</button>
    </div>
  </form>
</div>